export namespace Basket {
    /**
     * Basket item data
     */
    export interface IItemComponentData {
        qty?: number;
    }

    /**
     * Compont form data model
     */
    export interface ICouponFormData {
        coupon: string;
        checkout?: boolean;
    }

    export const ENDPOINTS = {
        probe: 'basket/probe',
        checkoutRemove: 'checkout/removeItem',
    };

    export const EVENTS = {
        view: 'basket.view'
    };

}
